<svg 
    [ngClass]="IconClass"
    version="1.1" 
    xmlns="http://www.w3.org/2000/svg" 
    xmlns:xlink="http://www.w3.org/1999/xlink" 
    [attr.height.px]="Height"
    [attr.width.px]="Width"
    viewBox="0 0 17 14">
    <path d="M5 12.75l3-1.5v-2.453l-3 1.281v2.672zM4.5 9.203l3.156-1.352-3.156-1.352-3.156 1.352zM13 12.75l3-1.5v-2.453l-3 1.281v2.672zM12.5 9.203l3.156-1.352-3.156-1.352-3.156 1.352zM9 6.914l3-1.289v-2.078l-3 1.281v2.086zM8.5 3.953l3.445-1.477-3.445-1.477-3.445 1.477zM17 8v3.25q0 0.281-0.148 0.523t-0.406 0.367l-3.5 1.75q-0.195 0.109-0.445 0.109t-0.445-0.109l-3.5-1.75q-0.039-0.016-0.055-0.031-0.016 0.016-0.055 0.031l-3.5 1.75q-0.195 0.109-0.445 0.109t-0.445-0.109l-3.5-1.75q-0.258-0.125-0.406-0.367t-0.148-0.523v-3.25q0-0.297 0.168-0.547t0.441-0.375l3.391-1.453v-3.125q0-0.297 0.168-0.547t0.441-0.375l3.5-1.5q0.18-0.078 0.391-0.078t0.391 0.078l3.5 1.5q0.273 0.125 0.441 0.375t0.168 0.547v3.125l3.391 1.453q0.281 0.125 0.445 0.375t0.164 0.547z"></path>
</svg>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/icons/icon-cubes.html